import RegisterTOTP, { RegisterTOTPButton } from './components/RegisterAuth';
import VerifyTOTP, { VerifyTOTPButton } from './components/VerifyAuth';
export default (editor, opts = {}) => {
  const dc = editor.DomComponents;
  const bm = editor.BlockManager;
  const { labels, types, labelTOTPCategory } = opts;
  RegisterTOTPButton(bm, labelTOTPCategory, labels.register_totp, types.register_totp);
  RegisterTOTP(dc, labels.register_totp, types.register_totp, opts);

  VerifyTOTPButton(bm, labelTOTPCategory, labels.verify_totp, types.verify_totp);
  VerifyTOTP(dc, labels.verify_totp, types.verify_totp, opts);
};
